import { connect } from 'react-redux';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { TripType } from '@eti/schema-types';
import { change } from 'redux-form';
import { AirportAvailability } from '@eti/components';
import { useState } from 'react';
import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { getUpsellProps } from '../../common/utils/productCardProps';
import { AvailabilityType, getAvailabilityList, getCartAvailability } from '../../common/utils/availability';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { LOUNGE } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import ProductLayout from '../../common/main-layout/ProductLayout';
import ViLayout from '../../common/components/vi-layout/ViLayout';
import { availablityProductCardGrid, availabilityReadMoreGrid } from '../../common/utils/styles';
import { getPriceDivided } from '../../common/utils/price';
import LoungeDrawer from './LoungeDrawer';
import { productTexts } from '../../common/utils/getProductTranslations';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  Main: MAIN_CARD_LAYOUT,
  VI: VI_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = LOUNGE;
const Lounge = ({
  className,
  form,
  isSelected,
  order,
  productSpecificTexts,
  productCode,
  productPosition,
  dispatch,
  tripType,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  var _productSegmentAvaila, _order$travelers$leng, _order$travelers2;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [lounge, setLounge] = useState();
  const {
    t
  } = useTranslation();
  const isMultiStop = tripType === TripType.MultiStop;
  const openDrawer = airport => {
    var _airport$loungeInfo;
    setLounge((_airport$loungeInfo = airport.loungeInfo) !== null && _airport$loungeInfo !== void 0 ? _airport$loungeInfo : undefined);
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setLounge(undefined);
  };
  const {
    rootElement,
    productData,
    translation
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    texts: productTexts[PRODUCT_NAME]
  });
  if (!productData) {
    return null;
  }
  const availabilityList = getAvailabilityList(order.bounds, (_productSegmentAvaila = productSpecificTexts === null || productSpecificTexts === void 0 ? void 0 : productSpecificTexts.productSegmentAvailabilityTexts) !== null && _productSegmentAvaila !== void 0 ? _productSegmentAvaila : [], AvailabilityType.PerSegment);
  const shouldDisplayAvailability = availabilityList.length > 0;
  const {
    loungeAvailabilityCardAddedStatus: addedStatus,
    loungeAvailabilityCardAddedTitle: addedTitle,
    loungeAvailabilityCardAvailabilityTitle: availabilityTitle,
    loungeAvailabilityCardAvailableStatus: availableStatus,
    loungeAvailabilityCardDeparting: departingTitle,
    loungeAvailabilityCardReturn: returnTitle,
    loungeAvailabilityCardSeeAll: seeAll,
    loungeAvailabilityCardStatusTooltip: statusTooltip,
    loungeAvailabilityCardUnavailableStatus: unavailableStatus,
    loungeCartPurchasedMessage,
    loungeDrawerAmenities,
    loungeDrawerCondition,
    loungeDrawerLocation,
    loungeDrawerOpeningFrom,
    loungeDrawerOpeningTitle,
    loungeDrawerOpeningTo,
    loungeDrawerTerminal,
    upSell
  } = translation;
  const handleAvailabilitySelection = value => {
    if (!dispatch) {
      return;
    }
    if (value === 'true' && shouldDisplayAvailability) {
      var _order$travelers;
      dispatch(change(form, `${PRODUCT_NAME}.cartBreakDown`, getCartAvailability(order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.length, loungeCartPurchasedMessage, availabilityList)));
    }
  };
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell, {
    shouldDisplayAvailability,
    availabilityList,
    tripType
  });
  const updatedExtraProps = {
    ...(productData === null || productData === void 0 ? void 0 : productData.extraProps),
    addedStatus,
    addedTitle,
    amenities: loungeDrawerAmenities,
    availabilityList,
    availabilityTitle,
    availableStatus,
    condition: loungeDrawerCondition,
    departingTitle,
    location: loungeDrawerLocation,
    onButtonChange: handleAvailabilitySelection,
    openingFrom: loungeDrawerOpeningFrom,
    openingTitle: loungeDrawerOpeningTitle,
    openingTo: loungeDrawerOpeningTo,
    returnTitle,
    seeAll,
    statusTooltip,
    terminal: loungeDrawerTerminal,
    unavailableStatus
  };
  const numberOfTravelers = (_order$travelers$leng = order === null || order === void 0 || (_order$travelers2 = order.travelers) === null || _order$travelers2 === void 0 ? void 0 : _order$travelers2.length) !== null && _order$travelers$leng !== void 0 ? _order$travelers$leng : 1;
  const price = priceUtils.formatPrice(getPriceDivided(productData.priceRaw, numberOfTravelers));
  const perTravelerLabel = t('Products.Price.Label.Per.Person');
  const updatedProductData = {
    ...productData,
    ...(!isSelected && {
      price,
      priceSuffix: perTravelerLabel
    }),
    extraProps: updatedExtraProps,
    upSell: upSellObject,
    isHighlighted: isUpsellHighlight,
    shouldDisplayUpsell
  };
  const availabilityProps = {
    isDrawerOpen,
    isMultiStop,
    openDrawer,
    productData: updatedProductData
  };
  const readMoreChild = shouldDisplayAvailability ? /*#__PURE__*/_jsx(AirportAvailability, {
    isDrawerOpen: isDrawerOpen,
    isMultiStop: isMultiStop,
    openDrawer: openDrawer,
    productData: updatedProductData,
    testid: "availability-readmore"
  }) : undefined;
  const sharedChildren = /*#__PURE__*/_jsxs(_Fragment, {
    children: [isSelected && shouldDisplayAvailability && /*#__PURE__*/_jsx(AirportAvailability, {
      ...availabilityProps,
      className: availablityProductCardGrid,
      isSelected: isSelected,
      testid: "availability-purchase"
    }), /*#__PURE__*/_jsx(LoungeDrawer, {
      isOpen: isDrawerOpen,
      labels: {
        loungeDrawerAmenities,
        loungeDrawerCondition,
        loungeDrawerLocation,
        loungeDrawerOpeningFrom,
        loungeDrawerOpeningTitle,
        loungeDrawerOpeningTo,
        loungeDrawerTerminal
      },
      loungeInfo: lounge,
      onClose: closeDrawer
    })]
  });
  switch (layoutType) {
    case VI_CARD_LAYOUT:
      return /*#__PURE__*/_jsxs(ViLayout, {
        productData: updatedProductData,
        ref: rootElement,
        children: [readMoreChild && /*#__PURE__*/_jsx(ViLayout.ReadMore, {
          customGrid: availabilityReadMoreGrid,
          children: readMoreChild
        }), sharedChildren]
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsxs(ProductLayout, {
        productData: updatedProductData,
        ref: rootElement,
        children: [readMoreChild && /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
          customGrid: availabilityReadMoreGrid,
          children: readMoreChild
        }), sharedChildren]
      });
  }
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(LOUNGE.name, form)(state)
});
export default connect(mapStateToProps)(Lounge);
//# sourceMappingURL=Lounge.js.map